import * as React from "react";

import type { MenuAnchorContextType } from "@1js/acui-menu";
import { MenuAnchorContext } from "@1js/acui-menu";
import {
  getShadowRenderingContextValue,
  ShadowRenderingContext,
} from "@1js/acui-shadow-rendering";

export type MenuContextProvidersProps = {
  isShadowRendering?: boolean;
  menuAnchorContextValue: MenuAnchorContextType;
  children?: JSX.Element;
};

export const MenuContextProviders = (props: MenuContextProvidersProps) => {
  const { isShadowRendering, menuAnchorContextValue, children } = props;
  return (
    <ShadowRenderingContext.Provider
      value={getShadowRenderingContextValue(!!isShadowRendering)}
    >
      <MenuAnchorContext.Provider value={menuAnchorContextValue}>
        {children}
      </MenuAnchorContext.Provider>
    </ShadowRenderingContext.Provider>
  );
};
